export default __webpack_public_path__ + "static/media/iconmonstr-linkedin-3.27a3f479.svg";